module.exports = __webpack_public_path__ + "static/media/04-validacao.275ff372.png";